import { Script, Env } from '@didi/utils'

const SDK_URL = '//open.mobile.qq.com/sdk/qqapi.js?_bid=152'

let cbs = []
let loaded = false
export function initMqq() {
	if (!Env.isMqq) {
		return
	}
	loadMqqSDK().then(() => {
		loaded = true
		next(null)
	}).catch((e) => {
		next(e)
	})

	function next(err) {
		cbs.forEach((cb) => {
			cb(err, window.mqq)
		})
	}
}

initMqq()

export function mqqReady(callback) {
	if (loaded) {
		callback(null, window.mqq)
	} else {
		cbs.push(callback)
	}
}

function loadMqqSDK() {
	if (window.mqq === undefined) {
		return Script.loadScript(SDK_URL)
	} else {
		return Promise.resolve()
	}
}
